import type { ExcelAddinSkinDefinition } from "../types"

export const aiaSkin: ExcelAddinSkinDefinition = {
	id: "aia",
	brandQueryValue: "aia",
	manifest: { dev: "manifest.xml", prod: "prod-manifest.xml" },
	features: { themeBuilderPage: true, showPrimaryNavPages: true },
	ui: {
		displayName: "AI Apollo",
		shortName: "AIA",
		datasetBrand: "aia",
		logoUrl: "assets/logo.svg",
		logoAlt: "AI Apollo",
		menuRootAriaLabel: "AI Apollo menu",
		menuTriggerAriaLabel: "Open AI Apollo menu",
		signInProductName: "AI Apollo",
		signInCardTitle: "Sign in to your account",
		refreshFormulasIdle: "Refresh AIA formulas",
		refreshFormulasLoading: "Refreshing…",
		refreshFormulasDone: "Up to date",
		refreshFormulasError: "Refresh failed",
		darkThemeSwitchLabel: "Dark theme",
		formulaNamespaceHint: "AIA",
	},
}
